import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App.tsx';

// Prevent URL mixing: if the dashboard is loaded on the PWA host, redirect to the canonical dashboard URL
// so the PWA does not "capture" the dashboard and the correct app loads.
const DASHBOARD_CANONICAL_HOST = 'spontane-content-manager.web.app';
const PWA_HOSTS = ['spontaneapp.web.app', 'www.spontaneapp.com'];
const host = window.location.hostname.toLowerCase();
if (PWA_HOSTS.includes(host)) {
  const url = new URL(window.location.href);
  url.host = DASHBOARD_CANONICAL_HOST;
  url.protocol = 'https:';
  window.location.replace(url.toString());
} else {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );
}
